// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

// Import third party modules
import angular from 'angular';

const MODULE_NAME = 'utilities';
angular.module(MODULE_NAME, [])

    .directive('compileHtml', ($compile) => {
      return {
        restrict: 'A',
        link: ($scope, element, attrs) => {
          $scope.$watch(attrs.compileHtml, function(val) {
            if (val) {
              element.html(val);
              $compile(element.contents())($scope);
            }
          });
        },
      };
    });

export default MODULE_NAME;
